<template>
  <div class="bill-info">
    <div class="title">{{ $t('PCUserInfo.index.647kboa09440') }}</div>
    <!-- <div class="item">
      <div class="item-left">BIC</div>
      <div class="item-right">
        <input v-model="form.bic" type="text" :placeholder="$t('PCUserInfo.index.647kboa09u40')">
      </div>
    </div>
    <div class="item">
      <div class="item-left">IBAN</div>
      <div class="item-right">
        <input v-model="form.iban" type="text" :placeholder="$t('PCUserInfo.index.647kboa09u40')">
      </div>
    </div> -->
    <div class="item">
      <div class="item-left">
        IBAN
        <el-tooltip effect="dark" placement="top">
          <div slot="content" style="white-space: pre-line">
            {{ $t('PCUserInfo.index.ibanTip') }}
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <div class="item-right">
        <input
          v-model="formattedIBAN"
          type="text"
          @input="formatIBAN"
          @blur="validateIBAN"
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
          maxlength="42"
        />
        <div v-if="errorMessage" class="error-tip">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'billInfo',
  props: {
    info: Object
  },
  data() {
    return {
      form: {
        // bic: '',
        iban: ''
      },
      errorMessage: '',
      lastCursorPos: 0 // 记录光标位置
    };
  },
  watch: {
    /**
     * 监听表单数据填写
     */
    form: {
      deep: true,
      immediate: true,
      handler: function (val) {
        // let flag = Boolean(val && val.iban)
        let flag = Boolean(val && val.iban && !this.errorMessage);
        let data = {
          flag,
          form: val
        };
        this.$emit('completeBill', data);
      }
    }
  },
  computed: {
    // 格式化后的 IBAN（带空格）
    formattedIBAN: {
      get() {
        return this.addSpaces(this.form.iban);
      },
      set(value) {
        // 去除空格并存储原始值
        this.form.iban = value.replace(/\s+/g, '');
      }
    }
  },
  mounted() {
    const { bic, iban } = this.info;
    this.form = {
      iban
    };
  },
  methods: {
    // 格式化输入（过滤非字母数字 + 转大写 + 自动加空格）
    formatIBAN(event) {
      // // 1. 过滤非字母数字字符
      // let value = event.target.value.replace(/[^a-zA-Z0-9]/g, "");

      // // 2. 转大写
      // value = value.toUpperCase();

      // // 3. 更新原始值（无空格）
      // this.form.iban = value;

      // // 4. 重新渲染格式化后的值（带空格）
      // num = this.addSpaces(value);
      // 保存光标位置
      this.lastCursorPos = event.target.selectionStart;

      // 1. 过滤非字母数字字符
      let value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');

      // 2. 转大写
      value = value.toUpperCase();

      // 3. 校验前两位必须为字母
      if (value.length > 0 && !/^[A-Z]{2}/.test(value)) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
        // value = value.slice(2) // 移除前两位非法字符
      } else {
        this.errorMessage = '';
      }

      // 4. 限制长度并更新
      this.form.iban = value.substring(0, 34);

      // 5. 格式化显示
      this.$nextTick(() => {
        // 恢复光标位置（考虑新增的空格）
        const input = this.$refs.ibanInput;
        const addedSpaces = Math.floor(this.lastCursorPos / 4);
        const newCursorPos = Math.min(this.lastCursorPos + addedSpaces, this.formattedIBAN.length);
        input.selectionStart = input.selectionEnd = newCursorPos;
      });
    },

    validateIBAN() {
      if (!this.form.iban) {
        this.errorMessage = this.$t('PCUserInfo.index.647kboa09u40');
      } else if (this.form.iban.length < 6) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
      } else if (!/^[A-Z]{2}[A-Z0-9]+$/.test(this.form.iban)) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
      }
    },

    // 每 4 位加空格
    addSpaces(value) {
      return value.replace(/(.{4})/g, '$1 ').trim();
    }
  }
};
</script>

<style scoped lang="less">
.bill-info {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px;
  .title {
    height: 84px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
    line-height: 84px;
  }
  .item {
    padding: 30px 0px 29px 0px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f4f5f7;
    position: relative;
    .item-left {
      width: 170px;
      font-size: 28px;
      color: #5d5f65;
      margin-right: 32px;
    }
    .item-right {
      flex: 1;
      color: #333;
      input {
        border: none;
        padding: 0;
        font-size: 28px;
      }
      input::placeholder {
        color: #999;
        font-size: 28px;
      }
      .error-tip {
        color: #f00;
        font-size: 24px;
        position: absolute;
        bottom: 0;
      }
      .input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          padding: 12px;
          color: #fff;
          background: #ff9600;
          font-size: 24px;
          border-radius: 10px;
        }
      }
    }
  }
  .item:last-child {
    border-bottom: none;
  }
}
</style>
